module.exports = __webpack_public_path__ + "static/img/gxg3.78e1b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxg3.png
// module id = /czJ
// module chunks = 2